export const config = {
  propsName: 'renderProps',
  name: 'SpInput',
  type: 'formTmpsConfig',
  icon: 'el-icon-edit',
  cnName: '文本框',
  base: {
    title: '文本框',
    padded: true,
    margin: [0, 0, 0, 0]
  },
  props: [
    // {
    //   type: () => import( '@/weappTmps/comps/flex/index.vue'),
    //   cmpPath:"/comps/flex/index.vue",
    //   key: 'flex',
    //   bind: {
    //     label: '排列方式',
    //   },
    //   on:{
    //   },
    //   value: null,
    // },
    {
      type: 'el-switch',
      key: 'required',
      bind: {
        label: '是否必填'
      },
      value: false
    },
    {
      type: () => import('@/weappTmps/formTmps/SpInput/comps/inputType.vue'),
      cmpPath: '/formTmps/SpInput/comps/inputType.vue',
      key: 'inputType',
      bind: {
        label: '输入框类型'
      },
      on: {},
      value: '1'
    },
    // {
    //   type: () => import( '@/weappTmps/comps/margin/index.vue'),
    //   cmpPath:"/comps/margin/index.vue",
    //   key: 'margin',
    //   bind: {
    //     label: '边距',
    //   },
    //   on:{
    //   },
    //   value: null,
    // },
    {
      type: 'el-input',
      key: 'title',
      bind: {
        label: '标题名称',
        placeholder: '请输入标题名称'
      },
      value: ''
    },
    {
      type: 'el-input',
      key: 'placeholder',
      bind: {
        label: '提示内容',
        placeholder: '请输入提示内容'
      },
      value: ''
    },
    {
      type: 'el-input',
      key: 'maxSize',
      bind: {
        label: '输入字数限制(最大限制500)',
        placeholder: '500',
        type: 'number',
        max: 500,
        maxlength: 3
      },
      value: '500'
    }
    // {
    //   type: 'el-input',
    //   key: 'defaultVal',
    //   bind: {
    //     label: '默认内容',
    //     placeholder:'请输入默认值'
    //   },
    //   value: '',
    // },

    // {
    //   type: () => import('./comps/test.vue'),
    //   cmpPath:"/formTmps/SpInput/comps/test.vue",
    //   key: 'test',
    //   bind: {
    //     label: 'import',
    //   },
    //   value: null,
    // },
    // {
    //   render:(h) => {
    //     return (
    //       <div class='avatar-wrap'>
    //         <div class='avatar-icon'>
    //           test render
    //         </div>
    //         <div class='avatar-info'>
    //           <div class='name'>item_name </div>
    //         </div>
    //       </div>
    //     )
    //   },
    //   key: 'test2',
    //   bind: {
    //     label: 'render',
    //   },
    //   value: null,
    // },
    // {
    //   // type: () => import('./comps/xxxx'),
    //   key: '',
    //   value: []
    // },
    // {
    //   type: 'btns',

    // }
  ]
}
